module.exports = __webpack_public_path__ + "img/newSolution_bg1.4f1eb15.webp";